import {createAction, createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {getOrderReviewTotalsApi} from 'api/custom';
import {
    OrderReviewTotalsSegmentsType,
    OrderReviewTotalsType,
} from 'desktop/types/orderReviewTotalsType';

export const initialState: OrderReviewTotalsType = {
    certificates: [],
    certificateTotal: 0,
    copay: 0,
    count: 0,
    currency: {code: 'USD', symbol: ''},
    discount: {
        certificates: [],
        coupons: [],
        price: 0,
        shipping: 0,
        withoutShipping: 0,
    },
    grandTotal: 0,
    isWithTaxCollect: false,
    items: [],
    shipping: {
        copayTax: 0,
        description: '',
        discount: 0,
        price: 0,
        priceInclTax: 0,
        shippingProtectionTax: 0,
        shippingProtectionTaxRate: 0,
        shippingTax: 0,
        shippingTaxRate: 0,
        title: '',
    },
    status: '',
    subtotal: 0,
    subtotalWithoutSpecial: 0,
    totalFinalPrice: 0,
    totalPrice: 0,
    totals: [],
    totalTax: 0,
};

export const getOrderReviewTotals = createAsyncThunk<
    {data: OrderReviewTotalsType},
    {collectTax: boolean; withTaxErrors: boolean},
    {rejectValue: {response: {data: {messages: {error: {message: string; code: number}[]}}}}}
>(
    'CHECKOUT@GET_ORDER_REVIEW_TOTALS',
    async ({collectTax = false, withTaxErrors}, {rejectWithValue}) => {
        try {
            return await getOrderReviewTotalsApi({collectTax, withTaxErrors});
        } catch (error) {
            return rejectWithValue(error);
        }
    },
);

export const updateOrderReviewTotals = createAction<OrderReviewTotalsSegmentsType[]>(
    'CHECKOUT@UPDATE_ORDER_REVIEW_SHIPPING_TOTALS',
);

/**
 * Order review totals reducer
 * @return {OrderReviewTotalsType} - order review totals state
 */
export const orderReviewTotals = createReducer(initialState, builder => {
    builder
        .addCase(getOrderReviewTotals.fulfilled, (state, action) => ({
            ...state,
            ...action.payload.data,
            status: 'FULFILLED',
        }))
        .addCase(getOrderReviewTotals.pending, (state, action) => ({
            ...state,
            isWithTaxCollect: action.meta.arg.collectTax,
            status: 'PENDING',
        }))
        .addCase(updateOrderReviewTotals, (state, action) => ({
            ...state,
            totals: action.payload,
        }));
});
